<template>
  <div v-if="data">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th scope="col">Student Exam Remarks</th>
          <th scope="col">Date</th>
          <th scope="col" class="text-right d-print-none">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="remark in data" :key="remark.id">
          <td>{{ remark.exam_remark }}</td>
          <td>{{ moment(remark.created_at).format(dateFormat) }}</td>
          <td class="text-right d-print-none">
            <span class="mr-md-2">
              <a href="javascript:;" class="text-primary neo-icon-btn" @click="showEditModal(remark.id)">
                <i class="fe fe-edit"></i>
              </a>
            </span>
            <span>
              <a href="javascript:;" class="text-danger neo-icon-btn" @click="handleDelete(remark.id)">
                <i class="fe fe-trash"></i>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'StudentExamRemarksTable',
  props: ['data', 'enrollmentId', 'classSectionExamId'],
  data: function() {
    return {
      dateFormat: 'DD-MM-YYYY',
    }
  },

  methods: {
    moment,
    showEditModal(remarkId) {
      // this.$refs.editFee.showModal(record.id)
      this.$eventBus.$emit('openExamRemarkEditModal', remarkId)
    },
    handleDelete(remarkId) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click Yes to delete the exam remark!`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/studentexamremark/' + remarkId)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Student exam remark deleted successfully',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleTableUpdate() {
      this.$emit('updateTable')
    },
  },
}
</script>
